import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          Sheth Younique Sion - Overview
        </h1>

        <p>
          Welcome to Promont by Sheth Realty, a prestigious 23-storey tower
          located in the heart of Sion, Mumbai. This premium pre-launch project
          offers luxurious 2 & 3 BHK residences with panoramic views, modern
          design, and world-class amenities. Strategically positioned just 5
          minutes from BKC (Bandra-Kurla Complex), Mumbai's prime Central
          Business District, Promont provides unmatched connectivity to key
          business, educational, and entertainment hubs. This ideal location
          makes it perfect for homeowners and investors seeking a blend of
          luxury and convenience.
          <br />
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Sheth Younique Sion - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              <li>
                <span>Exclusive Gated Community Living</span>
              </li>
              <li>
                <span>Prime Location Near BKC</span>
              </li>
              <li>
                <span>Seamless Connectivity in Sion </span>
              </li>
              <li>
                <span>25000 sq ft Sky Promenade for Great Views</span>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Easy Payment Subvention Plan</span>
              </li>
              <li>
                <span>Luxury Amenities & Clubhouse</span>
              </li>
              <li>
                <span>Infinity Pool & Jogging Track</span>
              </li>
              <li>
                <span>Panoramic Views of BKC</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
